import { DataType } from '@revelio/core';

import type { MultiMetricDataMap } from '../../../DataProvider/MultiMetricProvider';

export type CustomTableRow = Record<string, string | number | null>;

const makeKey = (parts: string[]): string => JSON.stringify(parts);

export const convertByMetricToTableRows = (
  byMetric: MultiMetricDataMap
): CustomTableRow[] => {
  const rowsByKey = new Map<string, CustomTableRow>();
  const order: string[] = [];
  const metricKeys: string[] = [];

  const getOrCreateRow = (
    key: string,
    dimensions: Record<string, string>
  ): CustomTableRow => {
    let row = rowsByKey.get(key);
    if (!row) {
      row = { ...dimensions };
      rowsByKey.set(key, row);
      order.push(key);
    }
    return row;
  };

  for (const [metric, series] of Object.entries(byMetric)) {
    if (!series) continue;

    if (series.type === DataType.SINGLE) {
      metricKeys.push(metric);
      for (const point of series.data) {
        const row = getOrCreateRow(makeKey([point.dim]), {
          dimension: point.dim,
        });
        row[metric] = point.value;
      }
    } else if (series.type === DataType.BREAKDOWN_SINGLE) {
      metricKeys.push(metric);
      for (const entry of series.data) {
        for (const breakdown of entry.breakdown) {
          const row = getOrCreateRow(makeKey([entry.dim, breakdown.dim]), {
            dimension: entry.dim,
            secondaryDimension: breakdown.dim,
          });
          row[metric] = breakdown.value;
        }
      }
    } else if (series.type === DataType.TIMESERIES) {
      metricKeys.push(metric);
      for (const entry of series.data) {
        for (const point of entry.timeseries) {
          const row = getOrCreateRow(makeKey([entry.dim, point.date]), {
            dimension: entry.dim,
            secondaryDimension: point.date,
          });
          row[metric] = point.value;
        }
      }
    }
  }

  return order.map((key) => {
    const row = rowsByKey.get(key) as CustomTableRow;
    for (const metric of metricKeys) {
      if (!(metric in row)) row[metric] = null;
    }
    return row;
  });
};
